var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90.6,
    height: 90.6,
    rx: 20,
    fill: "#EBD6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 32.2178H20.5V32.7178V73.0002V73.5002H21H52.4592H52.9592V73.0002V32.7178V32.2178H52.4592H21ZM51.0346 71.5756H22.4166V34.1344H51.0346V71.5756Z",
    fill: "#9933FF",
    stroke: "#9933FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2465 40.9968C47.7777 40.9968 48.2088 40.5658 48.2088 40.0346C48.2088 39.5034 47.7777 39.0723 47.2465 39.0723H26.1967C25.6655 39.0723 25.2344 39.5034 25.2344 40.0346C25.2344 40.5657 25.6655 40.9968 26.1967 40.9968H47.2465Z",
    fill: "#9933FF",
    stroke: "#9933FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2621 47.6174L47.2543 47.6172H47.2465H26.1967C25.6655 47.6172 25.2344 48.0483 25.2344 48.5795C25.2344 49.1107 25.6655 49.5418 26.1967 49.5418H47.2465C47.7777 49.5418 48.2088 49.1107 48.2088 48.5795C48.2088 48.0479 47.7725 47.6334 47.2621 47.6174Z",
    fill: "#9933FF",
    stroke: "#9933FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2465 58.0935C47.7777 58.0935 48.2088 57.6624 48.2088 57.1312C48.2088 56.6 47.7777 56.1689 47.2465 56.1689H26.1967C25.6655 56.1689 25.2344 56.6 25.2344 57.1312C25.2344 57.6624 25.6655 58.0935 26.1967 58.0935H47.2465Z",
    fill: "#9933FF",
    stroke: "#9933FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8805 64.9491L47.8675 64.9371L47.8537 64.9261C47.69 64.795 47.4773 64.7129 47.2465 64.7129H26.1967C25.6655 64.7129 25.2344 65.144 25.2344 65.6752C25.2344 66.2064 25.6655 66.6375 26.1967 66.6375H47.2465C47.7777 66.6375 48.2088 66.2064 48.2088 65.6752C48.2088 65.3783 48.0695 65.1235 47.8805 64.9491Z",
    fill: "#9933FF",
    stroke: "#9933FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9807 28.3496V27.8496H57.4807H26.0215H25.5215V28.3496V32.7174V33.2174H26.0215H26.9381H27.4381V32.7174V29.7662H56.0561V67.2154H52.4513H51.9513V67.7154V68.632V69.132H52.4513H57.4807H57.9807V68.632V28.3496Z",
    fill: "#9933FF",
    stroke: "#9933FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7912 22.6748V22.1748H63.2912H31.832H31.332V22.6748V28.3497V28.8497H31.832H32.7486H33.2486V28.3497V24.0914H61.8666V61.5406H57.4808H56.9808V62.0406V62.9572V63.4572H57.4808H63.2912H63.7912V62.9572V22.6748Z",
    fill: "#9933FF",
    stroke: "#9933FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6421 16.5H37.1421V17V22.6749V23.1749H37.6421H38.5587H39.0587V22.6749V18.4166H67.6767V55.8658H63.2908H62.7908V56.3658V57.2824V57.7824H63.2908H69.1013H69.6013V57.2824V17V16.5H69.1013H37.6421Z",
    fill: "#9933FF",
    stroke: "#9933FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulk);
export default __webpack_public_path__ + "static/media/bulk.d0a1e07205e04c4d465c48f22e6bdaa7.svg";
export { ForwardRef as ReactComponent };